import { useEffect } from 'react';

import { versionWatch } from '@/api/version';
import { MINUTE_MS } from '@/lib/timeUnits';

import { useExternalStore } from './useExternalStore';

// A tab left open for days still learns of a deploy without waiting for focus.
const RECHECK_EVERY_MS = 10 * MINUTE_MS;

/** True once a newer build is served than the one this page runs. */
export function useUiOutdated(): boolean {
    const isOutdated = useExternalStore(versionWatch);
    useEffect(() => {
        const recheck = (): void => {
            versionWatch.check();
        };
        const timer = setInterval(recheck, RECHECK_EVERY_MS);
        recheck();
        window.addEventListener('focus', recheck);
        return (): void => {
            clearInterval(timer);
            window.removeEventListener('focus', recheck);
        };
    }, []);
    return isOutdated;
}
